/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_MaturityInputs */

const en_gc_resources_compare_maturity = /** @type {(inputs: Gc_Resources_Compare_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product stage`)
};

const zh_gc_resources_compare_maturity = /** @type {(inputs: Gc_Resources_Compare_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品阶段`)
};

/**
* | output |
* | --- |
* | "Product stage" |
*
* @param {Gc_Resources_Compare_MaturityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_maturity = /** @type {((inputs?: Gc_Resources_Compare_MaturityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_MaturityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_maturity(inputs)
	return zh_gc_resources_compare_maturity(inputs)
});
export { gc_resources_compare_maturity as "gc.resources.compare.maturity" }